import { Button, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import React from 'react';

import { ActionsDrawerState } from './ActionsDrawer';
import { Icon } from 'packages/common-frontend/components/icons';

// Exports
export const ActionsDropdown = ({
  setActionsDrawerState,
  jobInProgress,
}: {
  setActionsDrawerState: React.Dispatch<
    React.SetStateAction<ActionsDrawerState | null>
  >;
  jobInProgress: boolean;
}) => {
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<Icon icon="chevron-down" />}
        variant="secondary-muted"
        colorScheme="gray"
        isDisabled={jobInProgress}
      >
        Actions
      </MenuButton>
      <MenuList zIndex={10}>
        <MenuItem onClick={() => setActionsDrawerState('repurchase')}>
          Repurchase by CSV
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
